import {observable, action } from 'mobx';

export default class ModalStore {
    rootStore;
    constructor(rootStore) {
        this.rootStore = rootStore;
    }

    @observable.shallow modal = {
        open:false,
        body:null,
        content:null,
        size:"md"
    };

    @action openModal = (bodyContent, content, callback, size) => {
        this.modal.open = true;
        this.modal.body = bodyContent;
        this.modal.content = content;
        this.modal.callback = callback ? callback : null;
        this.modal.size = size ? size : 'md';

        return this.modal;
    };

    @action closeModal = (result) => {
        this.modal.open = false;
        this.modal.body = null;

        if (this.modal.callback) {
            this.modal.callback();

            this.modal.callback = null;
        }

        return result;
    };


}